/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const itemImpactEntrySchema = z.object({
  crossesQuarter: z.boolean(),
  estimateChanged: z.boolean(),
  estimateDeltaHours: z.number().nullish(),
  estimateFromLabel: z.string().nullish(),
  estimateToLabel: z.string().nullish(),
  externalKey: z.string().nullish(),
  itemId: z.int(),
  name: z.string(),
  overdueByDays: z.int().nullish(),
  priorityChanged: z.boolean(),
  priorityDirection: z.enum(['UP', 'DOWN', 'UNCHANGED']),
  priorityPositionsMoved: z.int(),
  riskTransition: z.enum(['RESOLVED', 'ADDED', 'STILL_AT_RISK', 'STILL_SAFE']),
  scheduleFromFinish: z.iso.datetime().nullish(),
  scheduleFromStart: z.iso.datetime().nullish(),
  scheduleToFinish: z.iso.datetime().nullish(),
  scheduleToStart: z.iso.datetime().nullish(),
  severity: z.int(),
  slipDays: z.int().nullish(),
  startSlipDays: z.int().nullish(),
  teamChanged: z.boolean(),
  teamFrom: z.string().nullish(),
  teamTo: z.string().nullish(),
});
